module.exports = {
    LOGIN_RESULT: 'login_result',
    QUESTION_ASKED: 'QUESTION_ASKED',
    ASK_FINISHED: 'ASK_FINISHED',
    PLAYER_STATUS: 'PLAYER_STATUS',
    UNKNOWN_TOKEN: 'UNKNOWN_TOKEN',
    PLAYER_ADDED:'PLAYER_ADDED',
    PLAYER_REMOVED:'PLAYER_REMOVED',
    LOGGED_OUT: 'LOGGED_OUT',
    USER_LOGGED_OUT: 'USER_LOGGED_OUT',
    USER_LOGGED_IN: 'USER_LOGGED_IN',
    USER_DELETED: 'USER_DELETED',
    NUM_PLAYERS_CHANGED: 'num_players_changed',
    NUM_IMPROVISERS_CHANGED: 'num_improvisers_changed',
    ALL_USER_DELETED: 'ALL_USER_DELETED',
    DICE_LAUNCHED: 'DICE_LAUNCHED',
    RESULT_RESETTED: 'RESULT_RESETTED',
    QUESTION_LAUNCHED: 'QUESTION_LAUNCHED',
    SONG_LAUNCHED: 'SONG_LAUNCHED',
    TWO_WORDS_LAUNCHED: 'TWO_WORDS_LAUNCHED',
    SEVEN_WORDS_LAUNCHED: 'SEVEN_WORDS_LAUNCHED',
    VOTATION_LAUNCHED: 'VOTATION_LAUNCHED',
    VOTATION_AMAGGIORANZA_LAUNCHED: 'VOTATION_AMAGGIORANZA_LAUNCHED',
    CHOICE_LAUNCHED: ' CHOICE_LAUNCHED',
    VOTE_RECEIVED: 'VOTE_RECEIVED',
    VOTE_AMAGGIORANZA_RECEIVED: 'VOTE_AMAGGIORANZA_RECEIVED',
    CHOICE_RECEIVED: 'CHOICE_RECEIVED',
    PLAYER_SELECTED: 'PLAYER_SELECTED',
    PLAYER_TWO_SELECTED: 'PLAYER_TWO_SELECTED',
    PLAYER_RESETTED: 'PLAYER_RESETTED',
    RESULT_SENT:'RESULT_SENT',
    IMPROVISER_WAITING:'IMPROVISER_WAITING',
    NO_MORE_SONG:'NO_MORE_SONG',
    NO_MORE_QUESTION: 'NO_MORE_QUESTION',
    NO_MORE_TWO_WORDS: 'NO_MORE_TWO_WORDS',
    NO_MORE_SEVEN_WORDS: 'NO_MORE_SEVEN_WORDS',
    DATABASE_CHECKED:'DATABASE_CHECKED',
    DB_INITIATED: 'DB_INITIATED',
    IMPROVISER_ADDED: 'IMPROVISER_ADDED',
    IMPROVISER_REMOVED: 'IMPROVISER_REMOVED',
    GAME_ENDED: 'GAME_ENDED',
    I_VE_END: 'I_VE_END'

}


// WEBPACK FOOTER //
// ./src/events/ServerToClient.js